import React, { Component } from "react";
import classes from "./Child.module.css";
import styled from 'styled-components';
import { keyframes } from 'styled-components'
import checkmark from './checked.svg';




const Container = styled.div`
border-bottom: 1px solid #999;
margin: 5px 0px;
display: flex;
justify-content: space-between;
padding: 15px 15px 15px 15px;
`

const Checkbox = styled.div`
display: flex;
justify-content: center;
align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid green;
  border-color: ${props => props.checked ? 'green' : ''};
  margin-left: 10px;
  color: green;
  font-size: 32px;
`;

const Content = styled.input`
  flex-grow: 1;
  margin-left: 10px;
  font-size: 24px;
  text-decoration: ${props => props.checked ? 'line-through' : null};  
&:disabled { 
  background-color: transparent;
  border: none;
  font-size: 24px;
}
`;

const Remove = styled.div`
display: ${props => props.isShown ? 'block' : 'none'};
padding: 0px;
border: none;
background-color: transparent;
color: #af5b5e;
width: 40px;
height: 40px;
font-size: 30px;
`;

class Child extends Component {
  state = {
    buttonVisible: false
  }

  onShowDeleteButton = (e) => {
    console.log(e.target, e.currentTarget, 'mouseover');
    this.setState({buttonVisible: true});
  }

  onMouseLeave = e => {
    this.setState({buttonVisible: false});
  }


  render() {
    if(this.props.checked) {
      
    }

    return (
      <Container onMouseEnter={this.onShowDeleteButton} onMouseLeave={this.onMouseLeave} className={classes.container}>
        <label>
          <input
            onChange={this.props.check}
            checked={this.props.checked}
            className={classes.checkbox}
            type="checkbox"
          />
          <Checkbox className={classes.checkbox_fake} checked={this.props.checked}>
            {this.props.checked ? '✓' : ''}  
          </Checkbox>
        </label>
        <Content
          checked={this.props.checked}
          className={classes}
          onChange={this.props.change}
          onClick={this.props.click}
          disabled={this.props.disabled ? true : false}
          value={this.props.content}
          ref={this.props.inputRef}
          id={this.props.id}
          type="text"
        />
        <Remove
          isShown={this.state.buttonVisible}
          onClick={this.props.delete}
          className={classes.remove}
          type="button"
        >
          {" "}
          ×
        </Remove>
      </Container>
    );
  }
}

export default Child;
